/* eslint-disable @typescript-eslint/ban-types */
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  RadioGroup,
} from '@material-ui/core'
import { renderHelpersText, renderErrorInField } from '@flatsy/utils/Functions/form/Helpers'
import React, { useEffect } from 'react'
import { PrimaryRadio } from '../../../../../../MaterialUi/Radio'
import { FieldsType, SelectType, SingleFieldProps } from '../../../../Types'
import { useStyle } from './Style'

const RadioField = <T extends {}>({
  field,
  input,
  meta,
  values,
}: SingleFieldProps<T>): React.ReactElement => {
  const classes = useStyle()
  /**
   * @description render label or condition label
   * @param field
   * @param values
   */
  const renderLabelInField = (field: FieldsType, values: T) => {
    return field.conditional ? field.conditional(values).label : field.label
  }

  /**
   * @description format field value
   * @param val
   */
  const onChange = (val: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (field.changeEvent) {
      field.changeEvent(val.target.value)
    }
    input.onChange(val.target.value)
  }

  useEffect(() => {
    if (field.selectInitialValue && !input.value) {
      input.onChange(field.selectInitialValue)
    }
  }, [field.selectInitialValue])

  /**
   * @description render an array of react element
   * @param options
   */
  const renderOptions = (options: SelectType[] | undefined) => {
    if (options) {
      return options.map((select) => (
        <FormControlLabel
          value={select.value}
          key={select.value}
          control={<PrimaryRadio onChange={onChange} checked={select.value === input.value} />}
          label={select.label}
          className={classes.item}
          name={`${field.name}-${select.value}`}
          data-cy={`radio-${field.name}-${select.value}`}
        />
      ))
    }
    return <div />
  }

  return (
    <FormControl component="fieldset" error={renderErrorInField(meta)} name={field.name}>
      {field.label && field.label !== '' && (
        <FormLabel component="legend">{renderLabelInField(field, values)}</FormLabel>
      )}
      <RadioGroup
        aria-label={field.name}
        name={field.name}
        value={input?.value || field.selectInitialValue}
        className={classes.group}
      >
        {renderOptions(field.selectValue)}
      </RadioGroup>
      <FormHelperText>
        {renderHelpersText(field, meta.touched, meta.error, meta.submitError)}
      </FormHelperText>
    </FormControl>
  )
}

export default RadioField
